import { FCX, getFormattedThousand, Tooltip } from "@datassential/platform-ui-lib";
import { ReactNode, useId } from "react";
import CircleChart from "@components/CircleChart";
import './Metric.scss';
import Popup from "@components/Popup";
import { Metric as MetricEnum } from "@models/Metric";

function getMetricTitleRender(metricId?: MetricEnum) {
    switch (metricId) {
        case MetricEnum.HaveTriedIt:
            return <>have<br/>tried it</>
        case MetricEnum.HadManyTimes:
            return <>had<br/>many times</>
        default:
            return null;
    }
}

const Metric: FCX<{
    color: string;
    value: number;
    metricId?: MetricEnum;
    title: ReactNode;
    versus?: string;
    percentileValue: number;
    rank: number;
    rankTotal: number;
    tooltipTitle?: string;
    tooltipDescription?: string;
}> = ({
    color,
    metricId,
    value,
    title,
    versus,
    percentileValue,
    rank,
    rankTotal,
    tooltipTitle,
    tooltipDescription,
    className,
    testId,
    ...props
}) => {
    const id = useId();
    return (
        <div
            className="ProfileExperienceMetric"
            data-testid={testId}
            {...props}
        >
            <CircleChart
                className="ProfileExperienceMetric__chart"
                color={color}
                value={value}
                title={getMetricTitleRender(metricId) || title}
                percentileValue={percentileValue}
                tooltipId={id}
                testId="blockProfileExpMetricChart"
            />
            <div className="ProfileExperienceMetric__description">
                <div className="cl-secondary">Rank among</div>
                <div className="cl-secondary">{versus}</div>
                <div
                    className="ProfileExperienceMetric__description-rank"
                    data-testid="textProfileExpMetricRank"
                >
                    #{getFormattedThousand(rank)} of {getFormattedThousand(rankTotal)}
                </div>
            </div>
            <Popup hasWrapper={false}>
                <Tooltip
                    id={id}
                    place={"top-start"}
                >
                    <div
                        className="ProfileExperienceMetric__tooltip"
                    >
                        <div data-testid="textProfileExpMetricTooltipTitle">
                            <b dangerouslySetInnerHTML={{ __html: tooltipTitle ?? '' }} />
                        </div>
                        <div
                            data-testid="textProfileExpMetricTooltipDescription"
                            dangerouslySetInnerHTML={{ __html: tooltipDescription ?? '' }}
                        />
                    </div>
                </Tooltip>
            </Popup>
        </div>
    );
}

export default Metric;